import { FEATURE_PAGE_PATHS, type FeaturePageFamily } from "./featurePagePaths";
import type { ViewerLocale } from "./viewerPreferences";

export function buildFeaturePageLandingPath<F extends FeaturePageFamily>(
  locale: ViewerLocale,
  family: F,
): `/${ViewerLocale}${(typeof FEATURE_PAGE_PATHS)[F]}` {
  return `/${locale}${FEATURE_PAGE_PATHS[family]}`;
}
